import DependenciesLoader from '../../../model/loader/user-base-entities-loader'
import DefinitionGetter
                          from '../../../model/resource/getter/definitions-getter'
import ResourceGetter     from '../../../model/resource/getter/resource-getter'
import PDELinkGenerator   from '../../../model/wrapper/pde-link-params'

export default {
  name: 'HeaderPlusMenu',

  data () {
    return {
      items: [], definitionResponseData: null
    }
  },

  created () {
    let success = (response) => {
      this.definitionResponseData = response.data[0]

      this.items = this.definitionResponseData.Fields
    }

    DependenciesLoader.getPlusMenuData(success, (error) => {
      this.handleApiError(error)
    })
  },

  methods: {

    /**
     *
     * @param item
     * @return {{name, params}}
     * @private
     */
    _click (item, event) {
      event.preventDefault()
      this.$refs.holder.classList.remove('show')
      this.$refs.menu.classList.remove('show')

      if (this.definitionResponseData.Interpretation !== 'Plus') {
        let message = 'není implementováno zpracování pro interpretaci: ' +
          this.definitionResponseData.Interpretation
        this.handleApiError({ message: message })

        return
      }

      let success = (def) => {
        let response = def.response

        PDELinkGenerator.target = PDELinkGenerator.targetNewName
        PDELinkGenerator.redir  = 'grid'

        if (def.newRec) {
          let ruleParams = {
            ruleType: 'NEWREC',
            ruleName: def.newRec,
            where:    response.data[0].WhereCondition
          }

          ResourceGetter
            .get(def.viewName)
            .callBusinessRule(ruleParams)
            .then((response) => {
              PDELinkGenerator.defaults = response.data.values

              if (response.data.messages) {
                swal(response.data.messages, '')
              }

              const params = PDELinkGenerator.getParams(def)

              params.params['dashboardRedirect'] = true

              // otevreni editoru
              this.$router.push(params)

            })
            .catch((error) => {
              this.handleApiError(error)
            })
        }
        else {
          this.$router.push(PDELinkGenerator.getParams(def))
        }
      }, error    = (error) => {
        this.handleApiError(error)
      }, args     = {
        code: item.Field, idtEntityStructureFrom: item.idtEntityStructureFrom
      }

      return DefinitionGetter.getDataDefinition(args, success, error)
    }
  }

}
